import type { Profile, ProfileRequest } from "@shyne/shared/api";
import { UsersRepository } from "@/repositories/users.repository.ts";

export async function getCurrentUser(): Promise<Profile> {
    return UsersRepository.getCurrentUser();
}

export async function updateCurrentUser(changes: ProfileRequest): Promise<Profile> {
    return UsersRepository.updateCurrentUser(changes);
}

export async function uploadUserAvatar(file: File): Promise<Profile> {
    return UsersRepository.uploadUserAvatar(file);
}
